import { render, staticRenderFns } from "./WorkflowActionAddEvent.vue?vue&type=template&id=9b4337b2&scoped=true&"
import script from "./WorkflowActionAddEvent.vue?vue&type=script&lang=ts&"
export * from "./WorkflowActionAddEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4337b2",
  null
  
)

export default component.exports